module.exports = __webpack_public_path__ + "static/logo-d935aea3d9efac3cd58644187feb13b5.png";